import component from "./ProfileAttentionCreated.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAttentionCreated"

export default wrapVueComponent(componentName, component)
